function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M110.89 160.5C110.89 160.5 110.89 160.5 110.89 160.5C110.89 308.94 110.89 391.41 110.89 407.91C110.89 407.91 110.89 407.91 110.89 407.91C303.42 407.91 410.38 407.91 431.78 407.91C431.78 407.91 431.78 407.91 431.78 407.91C431.78 259.46 431.78 176.99 431.78 160.5C431.78 160.5 431.78 160.5 431.78 160.5C239.24 160.5 132.28 160.5 110.89 160.5Z",
  id: "a3zl3VZf3E"
}), /*#__PURE__*/React.createElement("path", {
  d: "M477.9 379.18L477.9 130.47L155.68 130.47L155.68 379.18L477.9 379.18ZM157.02 377.88L157.02 131.78L476.57 131.78L476.57 377.88L157.02 377.88Z",
  id: "bG0w6N6ty"
}), /*#__PURE__*/React.createElement("path", {
  d: "M251.68 455.75C251.68 455.75 251.68 455.75 251.68 455.75C251.68 456.68 251.68 457.19 251.68 457.3C251.68 457.3 251.68 457.3 251.68 457.3C474.74 457.3 598.66 457.3 623.45 457.3C623.45 457.3 623.45 457.3 623.45 457.3C623.45 456.37 623.45 455.86 623.45 455.75C623.45 455.75 623.45 455.75 623.45 455.75C400.39 455.75 276.47 455.75 251.68 455.75Z",
  id: "d2QHHgNCUl"
}), /*#__PURE__*/React.createElement("path", {
  d: "M361.77 199.26L211.93 263.67L361.58 328.51L361.77 199.26Z",
  id: "a56lmRaJCr"
}), /*#__PURE__*/React.createElement("path", {
  d: "M374.97 195.29C372.04 201.19 389.31 210.17 389.31 210.17C389.49 209.82 390.4 208.05 392.02 204.88C382.6 194.55 376.92 191.36 374.97 195.29Z",
  id: "c2F35Br4RO"
}), /*#__PURE__*/React.createElement("path", {
  d: "M392.72 216.25C394.54 219 400.59 221.86 400.59 221.86C400.62 221.88 400.8 221.98 401.12 222.16L406.83 225.48L414.31 229.83L437.99 243.61C456.74 250.94 467.16 255.01 469.24 255.83C469.48 251.56 469.71 247.3 469.93 243.27C470 242.06 470.01 240.86 469.99 239.66C469.59 239.54 469.19 239.43 468.78 239.35C459.54 237.42 455.61 234.62 455.61 234.62C453.8 233.56 439.34 225.04 437.53 223.98C437.53 223.98 423.34 215.14 414.33 211C413.07 210.41 411.91 209.92 410.9 209.56C402.75 206.64 389.57 201.91 389.57 201.91C389.56 201.93 389.5 202.03 389.41 202.21L386.15 208.38L384.63 211.27C388.81 212.77 391.51 214.43 392.72 216.25Z",
  id: "b4r2W9f1TR"
}), /*#__PURE__*/React.createElement("path", {
  d: "M392.72 216.25C394.54 219 400.59 221.86 400.59 221.86C400.62 221.88 400.8 221.98 401.12 222.16L406.83 225.48L414.31 229.83L437.99 243.61C456.74 250.94 467.16 255.01 469.24 255.83C469.48 251.56 469.71 247.3 469.93 243.27C470 242.06 470.01 240.86 469.99 239.66C469.59 239.54 469.19 239.43 468.78 239.35C459.54 237.42 455.61 234.62 455.61 234.62C453.8 233.56 439.34 225.04 437.53 223.98C437.53 223.98 423.34 215.14 414.33 211C413.07 210.41 411.91 209.92 410.9 209.56C402.75 206.64 389.57 201.91 389.57 201.91C389.56 201.93 389.5 202.03 389.41 202.21L386.15 208.38L384.63 211.27C388.81 212.77 391.51 214.43 392.72 216.25Z",
  id: "bpJfAcOms"
}), /*#__PURE__*/React.createElement("path", {
  d: "M389.75 199.12L239.91 263.54L389.57 328.37L389.75 199.12Z",
  id: "f1ECdzL2hb"
}), /*#__PURE__*/React.createElement("path", {
  d: "M389.58 320.11L389.57 328.37L239.91 263.54L249.49 259.42L389.58 320.11Z",
  id: "ar9zxMO3C"
}), /*#__PURE__*/React.createElement("path", {
  d: "M431.44 448.71L420.75 448.71L422.08 434.34L431.44 435L431.44 448.71Z",
  id: "a14ahTFbmA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M476.23 450.01L462.86 450.66L462.86 434.34L472.89 434.34L476.23 450.01Z",
  id: "f3d0IaxQXC"
}), /*#__PURE__*/React.createElement("path", {
  d: "M471.55 320.76C472.22 332.51 472.89 372.98 472.89 372.98C472.89 372.98 479.57 408.89 476.9 419.33C474.23 429.77 474.23 436.96 474.23 436.96C473.42 436.96 469.41 436.96 462.19 436.96L461.52 430.43C461.12 419.85 460.9 413.98 460.86 412.8C460.86 412.8 454.17 396.48 456.18 381.47C455.11 378.29 449.76 362.41 440.13 333.81C435.32 364.37 432.64 381.34 432.11 384.73C432.11 384.73 435.45 397.14 434.78 410.19C434.12 423.25 434.12 440.22 434.12 440.22C433.22 440.13 428.77 439.7 420.75 438.91C414.33 402.1 410.76 381.64 410.05 377.55C410.05 377.55 404.03 316.19 410.05 312.93C416.07 309.66 467.54 310.31 467.54 310.31C468.34 312.4 470.88 309.01 471.55 320.76Z",
  id: "a1jeWN4lPO"
}), /*#__PURE__*/React.createElement("path", {
  d: "M436.12 442.18C438.79 448.05 444.81 455.89 440.13 459.8C435.45 463.72 429.44 465.03 427.43 463.72C425.42 462.41 404.7 451.97 404.7 451.97C404.7 451.97 400.69 440.87 408.71 440.22C416.73 439.57 419.41 437.61 419.41 437.61C419.94 438.04 422.62 440.22 427.43 444.14C431.44 438.91 434.34 438.26 436.12 442.18Z",
  id: "a1ILUps64"
}), /*#__PURE__*/React.createElement("path", {
  d: "M476.23 441.52C478.91 443.48 480.91 451.97 480.91 451.97C480.91 451.97 496.96 464.37 481.58 464.37C466.2 464.37 456.18 466.98 457.51 461.11C458.85 455.23 460.86 445.44 460.86 445.44C460.86 445.44 467.54 436.96 473.56 446.09C474.09 445.18 473.56 439.57 476.23 441.52Z",
  id: "bC9bm9bg"
}), /*#__PURE__*/React.createElement("path", {
  d: "M431.44 164.74C440.67 164.74 448.15 172.05 448.15 181.06C448.15 190.08 440.67 197.38 431.44 197.38C422.21 197.38 414.73 190.08 414.73 181.06C414.73 172.05 422.21 164.74 431.44 164.74Z",
  id: "b3ug3yEGB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M451.16 208.15C455.17 210.76 424.42 211.42 424.42 211.42C424.42 211.42 426.43 196.4 424.42 192.49C425.76 192.09 432.44 190.14 444.48 186.61C446.26 199.23 448.49 206.41 451.16 208.15Z",
  id: "b7bVW27j5d"
}), /*#__PURE__*/React.createElement("path", {
  d: "M388.66 335.12C395.34 335.77 398.02 316.84 398.02 316.84C397.61 316.8 395.61 316.58 392 316.19C385.31 328.37 384.2 334.69 388.66 335.12Z",
  id: "b3iMXKvbYX"
}), /*#__PURE__*/React.createElement("path", {
  d: "M431.72 189.62C429.47 186.75 428.17 182.57 424.58 181.68C422.24 181.1 419.54 182.2 417.45 181.01C413.55 178.81 416.29 171.81 412.67 169.19C415.9 169.15 418.55 166.69 418.78 163.55C418.87 164.77 420.52 165.32 421.72 164.96C422.92 164.6 423.86 163.7 424.98 163.15C426.94 162.19 429.26 162.36 431.44 162.56C437.02 163.07 443.04 163.76 447.13 167.49C450.98 170.99 452.26 176.6 451.51 181.69C450.76 186.77 449.44 188.44 446.64 192.79C446.65 192.8 446.74 192.84 446.88 192.91C439.21 193.66 434.15 192.56 431.72 189.62Z",
  id: "b1Y1Scb33U"
}), /*#__PURE__*/React.createElement("path", {
  d: "M405.46 215.66L406.83 225.48L412.42 265.74C412.6 267.02 412.7 267.74 412.72 267.88C412.72 267.88 412.06 269.46 411.23 271.96C409.83 276.19 407.93 283.06 407.86 289.54C407.83 290.81 407.9 292.08 408.04 293.34C409.05 301.67 409.3 309.99 409.36 313.63C409.38 314.84 409.38 315.54 409.38 315.54C415.46 315.34 464.13 313.77 470.22 313.58C469.84 312.74 469.5 311.89 469.21 311.02C467.01 304.71 466.21 298.02 466.87 291.38C467.47 285.86 468.4 270.81 469.24 255.83C469.48 251.56 469.71 247.3 469.93 243.27C470 242.06 470.01 240.86 469.99 239.66C469.66 225.45 462.88 212.11 451.5 203.26C451.5 203.26 450.27 203.31 448.33 203.42C442.23 203.77 429.1 204.67 424.98 206.15C424.79 206.21 424.6 206.29 424.42 206.38C422.43 207.34 418.26 209.24 414.33 211C409.69 213.09 405.37 215.01 405.37 215.01C405.38 215.09 405.41 215.31 405.46 215.66Z",
  id: "c2xwHdkLEO"
}), /*#__PURE__*/React.createElement("path", {
  d: "M405.37 215.66C405.37 215.66 397.35 224.8 398.68 233.94C400.02 243.08 398.68 247.65 398.68 247.65C398.28 249.67 395.07 265.86 394.67 267.88C394.67 267.88 389.99 288.77 389.99 297.26C389.99 298.74 389.99 306.14 389.99 319.45C396.41 320.24 399.98 320.67 400.69 320.76C400.69 320.76 400.69 314.23 402.7 311.62C404.7 309.01 405.37 302.48 405.37 302.48C405.9 299.7 408.58 285.77 413.39 260.7L414.73 215.66C409.11 215.66 405.99 215.66 405.37 215.66Z",
  id: "d1BhH22RxZ"
}), /*#__PURE__*/React.createElement("path", {
  d: "M551.42 203.94C551.42 203.94 551.42 203.94 551.42 203.94C547.1 214.84 544.7 220.89 544.22 222.11C544.22 222.11 544.22 222.11 544.22 222.11C555.79 226.47 562.21 228.9 563.5 229.38C563.5 229.38 563.5 229.38 563.5 229.38C567.81 218.48 570.21 212.43 570.69 211.22C570.69 211.22 570.69 211.22 570.69 211.22C559.13 206.85 552.7 204.42 551.42 203.94Z",
  id: "d4mopn6EZS"
}), /*#__PURE__*/React.createElement("path", {
  d: "M567.99 228.34L575.57 209.21L555.28 201.55L547.7 220.67L567.99 228.34ZM549.1 220.1L555.92 202.89L574.17 209.78L567.36 227L549.1 220.1Z",
  id: "a2xSaJeKGM"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.85 79.45C52.85 79.45 52.85 79.45 52.85 79.45C64.17 83.25 70.46 85.37 71.72 85.79C71.72 85.79 71.72 85.79 71.72 85.79C75.75 74.34 77.99 67.98 78.44 66.71C78.44 66.71 78.44 66.71 78.44 66.71C67.12 62.91 60.83 60.79 59.57 60.37C59.57 60.37 59.57 60.37 59.57 60.37C55.54 71.82 53.3 78.18 52.85 79.45Z",
  id: "a7wxxIoL5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M77.19 62.36L57.33 55.69L50.26 75.78L70.12 82.44L77.19 62.36ZM69.48 81.11L51.61 75.11L57.97 57.03L75.85 63.03L69.48 81.11Z",
  id: "coj3SxeWA"
}), /*#__PURE__*/React.createElement("path", {
  d: "M582.21 456.43C582.4 456.36 600.92 449.43 609.6 433.71C618.28 417.99 614.03 399.07 613.99 398.88C613.97 398.82 613.91 398.54 613.79 398.02C613.28 398.21 613 398.31 612.94 398.33C612.75 398.4 594.23 405.33 585.55 421.05C576.87 436.76 581.12 455.69 581.16 455.88C581.18 455.93 581.24 456.22 581.36 456.74C581.87 456.55 582.15 456.45 582.21 456.43ZM582.52 454.64C581.82 450.75 579.61 435.05 586.94 421.78C594.27 408.5 608.92 401.68 612.63 400.12C613.33 404.01 615.54 419.7 608.21 432.98C600.87 446.27 586.23 453.08 582.52 454.64Z",
  id: "a1NHFlqUsk"
}), /*#__PURE__*/React.createElement("path", {
  d: "M581.37 455.56C581.37 455.56 600.65 458.91 616.24 449.74C631.84 440.58 637.85 422.38 637.85 422.38C637.85 422.38 618.57 419.04 602.97 428.2C587.37 437.36 585.69 450.09 581.37 455.56Z",
  id: "cSZSUvBA4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 16.36C0 16.36 0 16.36 0 16.36C0 17.14 0 17.58 0 17.67C0 17.67 0 17.67 0 17.67C374.23 17.67 582.14 17.67 623.72 17.67C623.72 17.67 623.72 17.67 623.72 17.67C623.72 16.88 623.72 16.45 623.72 16.36C623.72 16.36 623.72 16.36 623.72 16.36C249.49 16.36 41.58 16.36 0 16.36Z",
  id: "e8l168EexP"
}), /*#__PURE__*/React.createElement("path", {
  d: "M610.98 0C614.33 0 617.04 2.65 617.04 5.92C617.04 9.18 614.33 11.83 610.98 11.83C607.64 11.83 604.92 9.18 604.92 5.92C604.92 2.65 607.64 0 610.98 0Z",
  id: "bVFwjZWT1"
}), /*#__PURE__*/React.createElement("path", {
  d: "M592.3 0C595.65 0 598.36 2.65 598.36 5.92C598.36 9.18 595.65 11.83 592.3 11.83C588.96 11.83 586.25 9.18 586.25 5.92C586.25 2.65 588.96 0 592.3 0Z",
  id: "ds7sitfXt"
}), /*#__PURE__*/React.createElement("path", {
  d: "M573.63 0C576.97 0 579.68 2.65 579.68 5.92C579.68 9.18 576.97 11.83 573.63 11.83C570.28 11.83 567.57 9.18 567.57 5.92C567.57 2.65 570.28 0 573.63 0Z",
  id: "dItOa41Vt"
}), /*#__PURE__*/React.createElement("path", {
  d: "M249.52 61.01C249.52 61.01 249.52 61.01 249.52 61.01C249.52 61.95 249.52 62.47 249.52 62.57C249.52 62.57 249.52 62.57 249.52 62.57C335.12 62.57 382.67 62.57 392.18 62.57C392.18 62.57 392.18 62.57 392.18 62.57C392.18 61.63 392.18 61.11 392.18 61.01C392.18 61.01 392.18 61.01 392.18 61.01C306.58 61.01 259.03 61.01 249.52 61.01Z",
  id: "a3NFO2YMH"
}), /*#__PURE__*/React.createElement("path", {
  d: "M249.52 71.96C249.52 71.96 249.52 71.96 249.52 71.96C249.52 72.9 249.52 73.42 249.52 73.53C249.52 73.53 249.52 73.53 249.52 73.53C335.12 73.53 382.67 73.53 392.18 73.53C392.18 73.53 392.18 73.53 392.18 73.53C392.18 72.59 392.18 72.07 392.18 71.96C392.18 71.96 392.18 71.96 392.18 71.96C306.58 71.96 259.03 71.96 249.52 71.96Z",
  id: "bDxwQMZD4"
}), /*#__PURE__*/React.createElement("path", {
  d: "M249.52 82.92C249.52 82.92 249.52 82.92 249.52 82.92C249.52 83.86 249.52 84.38 249.52 84.48C249.52 84.48 249.52 84.48 249.52 84.48C335.12 84.48 382.67 84.48 392.18 84.48C392.18 84.48 392.18 84.48 392.18 84.48C392.18 83.55 392.18 83.02 392.18 82.92C392.18 82.92 392.18 82.92 392.18 82.92C306.58 82.92 259.03 82.92 249.52 82.92Z",
  id: "gtWgifvyz"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a3zl3VZf3E",
  opacity: 1,
  fill: "#2a9f8b",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a3zl3VZf3E",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bG0w6N6ty",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bG0w6N6ty",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d2QHHgNCUl",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d2QHHgNCUl",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a56lmRaJCr",
  opacity: 1,
  fill: "#514e7f",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a56lmRaJCr",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c2F35Br4RO",
  opacity: 1,
  fill: "#a0616a",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c2F35Br4RO",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b4r2W9f1TR",
  opacity: 1,
  fill: "#d0cde1",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b4r2W9f1TR",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bpJfAcOms",
  opacity: 1,
  fill: "#4c4a78",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bpJfAcOms",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f1ECdzL2hb",
  opacity: 1,
  fill: "#27bba1",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f1ECdzL2hb",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ar9zxMO3C",
  opacity: 1,
  fill: "#000000",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ar9zxMO3C",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a14ahTFbmA",
  opacity: 1,
  fill: "#a0616a",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a14ahTFbmA",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f3d0IaxQXC",
  opacity: 1,
  fill: "#a0616a",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#f3d0IaxQXC",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a1jeWN4lPO",
  opacity: 1,
  fill: "#2f2e41",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a1jeWN4lPO",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a1ILUps64",
  opacity: 1,
  fill: "#2f2e41",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a1ILUps64",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bC9bm9bg",
  opacity: 1,
  fill: "#2f2e41",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bC9bm9bg",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b3ug3yEGB",
  opacity: 1,
  fill: "#a0616a",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b3ug3yEGB",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b7bVW27j5d",
  opacity: 1,
  fill: "#a0616a",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b7bVW27j5d",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b3iMXKvbYX",
  opacity: 1,
  fill: "#a0616a",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b3iMXKvbYX",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b1Y1Scb33U",
  opacity: 1,
  fill: "#2f2e41",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#b1Y1Scb33U",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c2xwHdkLEO",
  opacity: 1,
  fill: "#514e7f",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c2xwHdkLEO",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d1BhH22RxZ",
  opacity: 1,
  fill: "#514e7f",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d1BhH22RxZ",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d4mopn6EZS",
  opacity: 1,
  fill: "#27bba1",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#d4mopn6EZS",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a2xSaJeKGM",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a2xSaJeKGM",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a7wxxIoL5",
  opacity: 1,
  fill: "#27bba1",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a7wxxIoL5",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#coj3SxeWA",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#coj3SxeWA",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a1NHFlqUsk",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a1NHFlqUsk",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cSZSUvBA4",
  opacity: 1,
  fill: "#27bba1",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#cSZSUvBA4",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e8l168EexP",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#e8l168EexP",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bVFwjZWT1",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bVFwjZWT1",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ds7sitfXt",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#ds7sitfXt",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dItOa41Vt",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#dItOa41Vt",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a3NFO2YMH",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a3NFO2YMH",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bDxwQMZD4",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#bDxwQMZD4",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#gtWgifvyz",
  opacity: 1,
  fill: "#3f3d56",
  fillOpacity: 1
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#gtWgifvyz",
  opacity: 1,
  fillOpacity: 0,
  stroke: "#000000",
  strokeWidth: 1,
  strokeOpacity: 0
})))));

var SvgCreateMedia = function SvgCreateMedia(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 1600,
    height: 1600,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCreateMedia, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/create-media.3cce73dd.svg";
export { ForwardRef as ReactComponent };